import React from "react";

const DraftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M13.3172 10.0355C13.5744 9.86262 13.9229 9.93076 14.0959 10.1879L14.6258 10.9763C14.7987 11.2334 14.7306 11.582 14.4735 11.7549L10.6011 14.3591C10.5086 14.4213 10.3994 14.4547 10.2879 14.4548L9.01839 14.4555C8.81921 14.4554 8.6834 14.2532 8.75863 14.0687L9.23844 12.893C9.28055 12.7899 9.35244 12.7018 9.44482 12.6397L13.3172 10.0355Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.1792 2.17616C7.70115 1.94128 8.29918 1.94128 8.82113 2.17616L13.4878 4.27577C14.2054 4.59875 14.6668 5.313 14.6668 6.09998V8.76405L14.4787 8.49517C14.2502 8.15536 13.7892 8.06548 13.4494 8.294L8.33219 11.7354C8.2101 11.8175 8.11505 11.9338 8.05941 12.07L7.42529 13.6241C7.40047 13.6851 7.39286 13.7477 7.3999 13.807H3.3335C2.22904 13.807 1.33367 12.9114 1.3335 11.807V6.09998C1.3335 5.313 1.79489 4.59875 2.51253 4.27577L7.1792 2.17616ZM12.5549 6.10389C12.3634 5.81671 11.9876 5.72582 11.689 5.88384L11.6304 5.919L8.36995 8.09282C8.17403 8.2233 7.9258 8.23962 7.71696 8.14165L7.63037 8.09282L4.36995 5.919L4.31136 5.88384C4.01272 5.72582 3.63693 5.81671 3.44548 6.10389C3.25413 6.39115 3.31479 6.77322 3.57568 6.98801L3.63037 7.02837L6.89079 9.2022L7.01904 9.28097C7.67106 9.64815 8.47986 9.62184 9.10954 9.2022L12.37 7.02837L12.4246 6.98801C12.6855 6.77322 12.7462 6.39115 12.5549 6.10389Z"
        fill="white"
      />
    </svg>
  );
};

export default DraftIcon;
